(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const setFinalState = (root) => {
    root.classList.add('is-visible');
    root.querySelectorAll('[data-xomd-count]').forEach((counter) => {
      counter.textContent = counter.dataset.xomdTarget || counter.textContent;
    });
    root.querySelectorAll('[data-xomd-bar]').forEach((bar) => {
      bar.style.setProperty('--xomd-bar-width', `${bar.dataset.xomdBar}%`);
    });
  };

  const animateCounter = (counter) => {
    const target = Number.parseFloat(counter.dataset.xomdTarget || '0');
    if (!Number.isFinite(target)) return;

    const decimals = (String(target).split('.')[1] || '').length;
    const duration = 1200;
    const start = performance.now();

    const frame = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 4);
      counter.textContent = (target * eased).toFixed(decimals);
      if (progress < 1) requestAnimationFrame(frame);
    };

    requestAnimationFrame(frame);
  };

  const activate = (root) => {
    if (root.classList.contains('is-visible')) return;
    root.classList.add('is-visible');
    root.querySelectorAll('[data-xomd-count]').forEach(animateCounter);
    root.querySelectorAll('[data-xomd-bar]').forEach((bar) => {
      bar.style.setProperty('--xomd-bar-width', `${bar.dataset.xomdBar}%`);
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-xomd-reveal]').forEach((root) => {
      if (root.dataset.xomdReady === 'true') return;
      root.dataset.xomdReady = 'true';

      if (reduceMotion || window.Shopify?.designMode) {
        setFinalState(root);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            activate(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.16, rootMargin: '0px 0px -8% 0px' }
      );

      observer.observe(root);
    });
  };

  const initHeader = () => {
    let ticking = false;
    const update = () => {
      document.body.classList.toggle('xomd-header-scrolled', window.scrollY > 18);
      ticking = false;
    };

    update();
    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
  };

  const initParallax = (scope = document) => {
    if (reduceMotion || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    scope.querySelectorAll('[data-xomd-parallax-root]').forEach((root) => {
      if (root.dataset.xomdParallaxReady === 'true') return;
      root.dataset.xomdParallaxReady = 'true';
      const image = root.querySelector('img');
      if (!image) return;

      root.addEventListener('pointermove', (event) => {
        const bounds = root.getBoundingClientRect();
        const x = (event.clientX - bounds.left) / bounds.width - 0.5;
        const y = (event.clientY - bounds.top) / bounds.height - 0.5;
        image.style.transform = `scale(1.02) translate(${x * -0.8}%, ${y * -0.8}%)`;
      });
      root.addEventListener('pointerleave', () => {
        image.style.transform = '';
      });
    });
  };

  const initMediaDownloads = (scope = document) => {
    scope.querySelectorAll("main[data-template='page.media-kit'] [id*='image_gallery'] .card").forEach((card) => {
      if (card.querySelector('.xomd-media-download')) return;
      const image = card.querySelector('img');
      if (!image) return;
      const existingLink = [...card.querySelectorAll('a')].find((link) => /download/i.test(link.textContent || ''));
      if (existingLink) {
        existingLink.classList.add('xomd-media-download', 'xomd-premium-text-link');
        return;
      }
      const link = document.createElement('a');
      link.className = 'xomd-media-download xomd-premium-text-link';
      link.href = image.currentSrc || image.src;
      link.download = '';
      link.innerHTML = 'Download image <span aria-hidden="true">↓</span>';
      card.append(link);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    init();
    initHeader();
    initParallax();
    initMediaDownloads();
  });
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
    initParallax(event.target);
    initMediaDownloads(event.target);
  });
})();
